/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */
import * as React from 'react';

export interface ICookiePolicyPlaceholderDispatchProps {
  setPolicyHtml: (html: string) => void;
}

const CookiePolicyPlaceholder: React.FC<ICookiePolicyPlaceholderDispatchProps> =
  ({ setPolicyHtml }) => {
    const setHtml = () =>
      setPolicyHtml(
        document.getElementById('ot-sdk-cookie-policy')?.innerHTML || ''
      );
    // add global function handler for cookie-settings script
    (global as any).OptanonWrapper = () => setHtml();

    React.useEffect(() => {
      setHtml();
    });

    return (
      <div className='d-none'>
        <div id='ot-sdk-cookie-policy'></div>
        <a id='cookie-settings-link' className='optanon-show-settings'></a>
      </div>
    );
  };

export default CookiePolicyPlaceholder;
